import './moving-select.component.scss'
// import './moving-select.component.pug'
import '../../helpers/styles/modules/checkbox.scss'
import { Application } from '../../helpers/app'

function activateCardFromIndex(index) {
  if (window.matchMedia('(max-width: 480px)').matches) {
    const card = document.querySelectorAll('.moving-card')[index]
    changeMoving({ target: card })
    const navButton = document.querySelectorAll('.moving-select-nav button')[
      index
    ]
    const activeButton = document.querySelector(
      '.moving-select-nav button.is-active'
    )
    if (navButton) {
      navButton.classList.add('is-active')
      if (activeButton) {
        activeButton.classList.remove('is-active')
      }
    }
  }
}
let movingSlider = null
Application.swiper().then(({ Swiper }) => {
  movingSlider = new Swiper('.moving-select-items .swiper-container', {
    slidesPerView: 1,
    spaceBetween: 16,
    loop: false,
    breakpoints: {
      992: {
        slidesPerView: 4,
        spaceBetween: 24
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 16
      },
      480: {
        slidesPerView: 2,
        spaceBetween: 16
      }
    },
    on: {
      slideChange() {
        activateCardFromIndex(this.realIndex)
      },
      init() {
        activateCardFromIndex(this.realIndex)
      }
    }
  })
  Application.lozad('.moving-select-items .swiper-container .lozad')
})
const movingState = {
  id: null,
  path: null,
  _node: null,
  _toHome: false,
  get query() {
    return `${this.path}?movingId=${this.id}&isHome=${this.toHome}`
  },

  set node(node) {
    if (this.node) {
      this.node.classList.remove('moving-card-active')
    }
    this._node = node
    this.node.classList.add('moving-card-active')

    document.querySelector('.moving-select-home__price').innerText =
      '$' + parseFloat(this.node.dataset.movePrice).toFixed(2)
  },
  get node() {
    return this._node
  },

  set toHome(toHome) {
    this._toHome = toHome
  },
  get toHome() {
    return this._toHome
  }
}
function changeMoving(event) {
  const card = event.target.closest('.moving-card')
  if (card) {
    movingState.id = card.dataset.cardId
    movingState.node = card
  }
}

export function activate() {
  changeMoving({ target: document.querySelector('.moving-card') })

  const cards = document.querySelectorAll('.moving-card')
  if (cards.length > 0) {
    cards.forEach(card => {
      card.addEventListener('click', changeMoving)
    })
  }

  const toHomeNode = document.getElementById('moving-to-home')
  if (toHomeNode) {
    toHomeNode.addEventListener('change', () => {
      movingState.toHome = toHomeNode.checked
    })
  }

  const movingSubmit = document.getElementById('movingSubmit')
  if (movingSubmit) {
    movingState.path = movingSubmit.dataset.path || '/'
    movingSubmit.addEventListener('mouseenter', () => {
      movingSubmit.href = movingState.query
    })
    movingSubmit.addEventListener('click', () => {
      movingSubmit.href = movingState.query
    })
  }

  document.querySelectorAll('.moving-select-nav button').forEach(button => {
    button.addEventListener('click', () => {
      const index = Array.from(button.parentNode.children).indexOf(button)
      movingSlider.slideTo(index)
    })
  })
}
